import { env } from 'config';
import { MerchantRequest, QueryParams } from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/merchant-payout-requests`;

export const merchantPayoutRequestsApi = {
  getForOrder:
    (orderId: string) =>
    async (params?: Partial<QueryParams>): Promise<MerchantRequest[]> =>
      (await apiUtils.getWithQueryParams(`${url}/order/${orderId}`, params))
        .data,
};
